import { Component, Input, OnInit } from '@angular/core';
import { HeatTraceTestsWeekSummary } from '@completion/models';

@Component({
  selector: 'app-week-header',
  templateUrl: './week-header.component.html',
  styleUrls: ['./week-header.component.scss'],
  standalone: false,
})
export class WeekHeaderComponent implements OnInit {
  @Input() data: HeatTraceTestsWeekSummary;
  @Input() isCurrentWeek = false;

  progress = 0;

  ngOnInit() {
    setTimeout(() => {
      this.progress = (this.data.done / this.data.count) * 100;
    }, 55);
  }
}
